// src/responsive/utils.ts
import { isObject } from "@teamsparta/stack-utils";
import { isValidElement } from "react";
function breakpointMapper(breakpoints, targetObject, callback) {
  return Object.entries(targetObject).map(([key, value]) => {
    const breakpoint = breakpoints[key];
    if (breakpoint == null) {
      console.info(`Breakpoint ${key} \uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.`);
      return null;
    }
    return callback(breakpoint, value);
  }).filter((item) => item).sort((a, b) => a.breakpoint - b.breakpoint);
}
function mapResponsive(breakpoints, targetObject, callback) {
  if (!isObject(targetObject)) {
    return [
      callback(0, targetObject)
    ];
  }
  return breakpointMapper(
    breakpoints,
    targetObject,
    callback
  );
}
function mapResponsiveElement(breakpoints, targetObject, callback) {
  if (isValidElement(targetObject)) {
    return [
      callback(0, targetObject)
    ];
  }
  return mapResponsive(breakpoints, targetObject, callback);
}
function mapResponsiveValue(source, valueMap) {
  if (!isObject(source)) {
    return valueMap[source];
  }
  const result = {};
  Object.entries(source).forEach(([breakpoint, value]) => {
    if (value !== void 0) {
      result[breakpoint] = valueMap[value];
    }
  });
  return result;
}

export {
  breakpointMapper,
  mapResponsive,
  mapResponsiveElement,
  mapResponsiveValue
};
